import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import ValidationSteps from 'components/common/validation-steps';
import cx from 'classnames';

export default function HowToPark({ parkingPass }) {
  if (!(parkingPass && parkingPass.validation)) { return null; }

  const bsClasses = cx({
    'col-xs-10': true,
    'col-xs-offset-1': true,
    'col-md-12': true,
    'col-md-offset-0': true,
    'padding-0': true,
    'text-color-dark-slate': true,
    'text-size-12': true,
  });

  return (
    <div className="row">
      <h6 className={`h6-sg text-color-dark-slate text-weight-medium ${bsClasses} uppercase`}>
        <FormattedMessage id="parking-pass.how-to-park" defaultMessage="HOW TO PARK" />
      </h6>
      <ValidationSteps validation={parkingPass.validation} className={`text-weight-book ${bsClasses}`} />
    </div>
  );
}

HowToPark.propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
};
